<template>
  <div class="modal-card" style="width: auto">
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <header class="modal-card-head">
      <p class="modal-card-title has-text-centered">
        {{ $tc("scaleProducts.scaleProduct", 1) }}
      </p>
    </header>

    <section class="modal-card-body">
      <b-tabs
        position="is-centered"
        class="block"
        expanded
        @input="changeTabsStyle"
      >
        <b-tab-item
          :label="
            scaleProductBeingEdited._id
              ? $t('scaleProducts.editProduct')
              : $t('scaleProducts.createProduct')
          "
        >
          <br />
          <div class="columns">
            <div class="column">
              <b-field
                :label="$t('scaleProducts.saleType')"
                label-position="on-border"
              >
                <b-select
                  v-model="scaleProduct.saleType"
                  :placeholder="$t('scaleProducts.select')"
                  expanded
                >
                  <option value="" disabled>
                    {{ $t("scaleProducts.select") }}
                  </option>

                  <option value="weight">
                    {{ $t("scaleProducts.saleTypeWeight") }}
                  </option>

                  <option value="unit">
                    {{ $t("scaleProducts.saleTypeUnit") }}
                  </option>
                </b-select>
              </b-field>
            </div>

            <div class="column">
              <b-field
                :label="$t('scaleProducts.option')"
                label-position="on-border"
              >
                <b-select
                  v-model="scaleProduct.option"
                  :placeholder="$t('scaleProducts.select')"
                  expanded
                >
                  <option value="" disabled>
                    {{ $t("scaleProducts.select") }}
                  </option>

                  <option value="totalPrice">
                    {{ $t("scaleProducts.totalPrice") }}
                  </option>

                  <option value="weightQty">
                    {{ $t("scaleProducts.weightQty") }}
                  </option>
                </b-select>
              </b-field>
            </div>

            <div class="column">
              <b-field
                :label="$t('scaleProducts.codeDigitsQty')"
                label-position="on-border"
              >
                <b-select
                  v-model="scaleProduct.digits"
                  :placeholder="$t('scaleProducts.select')"
                  expanded
                >
                  <option value="" disabled>
                    {{ $t("scaleProducts.select") }}
                  </option>
                  <option :value="4">4</option>
                  <option :value="5">5</option>
                  <option :value="6">6</option>
                </b-select>
              </b-field>
            </div>
          </div>

          <div class="columns">
            <div class="column is-two-thirds">
              <b-field :label="$t('common.name')" label-position="on-border">
                <b-input
                  v-model="scaleProduct.n"
                  :placeholder="$t('scaleProducts.productName')"
                  expanded
                ></b-input>
              </b-field>
            </div>

            <div class="column">
              <b-field
                :label="$t('scaleProducts.code')"
                label-position="on-border"
              >
                <b-input
                  v-model="scaleProduct.code"
                  :placeholder="
                    scaleProduct.digits === 5
                      ? '#####'
                      : scaleProduct.digits === 6
                      ? '######'
                      : '####'
                  "
                  type="tel"
                  expanded
                  :disabled="scaleProduct._id"
                ></b-input>
              </b-field>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <b-field
                :label="$t('scaleProducts.saleUnit')"
                label-position="on-border"
              >
                <b-select
                  v-model="scaleProduct.unit"
                  :placeholder="$t('scaleProducts.select')"
                  expanded
                >
                  <option value="" disabled>
                    {{ $t("scaleProducts.select") }}
                  </option>

                  <option value="kg" v-if="scaleProduct.saleType === 'weight'">
                    kg
                  </option>

                  <option
                    value="100g"
                    v-if="scaleProduct.saleType === 'weight'"
                  >
                    100g
                  </option>

                  <option value="10g" v-if="scaleProduct.saleType === 'weight'">
                    10g
                  </option>

                  <option value="1g" v-if="scaleProduct.saleType === 'weight'">
                    1g
                  </option>

                  <option value="un" v-if="scaleProduct.saleType === 'unit'">
                    un
                  </option>
                </b-select>
              </b-field>
            </div>

            <div class="column">
              <b-field
                :label="
                  scaleProduct.unit !== ''
                    ? `${$t('scaleProducts.costPer')} ${scaleProduct.unit}`
                    : $t('scaleProducts.cost')
                "
                label-position="on-border"
              >
                <money
                  v-model="scaleProduct.lc"
                  v-bind="money"
                  class="input is-expanded"
                ></money>
              </b-field>
            </div>

            <div class="column">
              <b-field
                :label="$t('scaleProducts.isAlcoholic')"
                label-position="on-border"
              >
                <b-select
                  v-model="scaleProduct.a"
                  :placeholder="$t('scaleProducts.select')"
                  expanded
                >
                  <option value="" disabled>
                    {{ $t("scaleProducts.select") }}
                  </option>

                  <option :value="false">
                    {{ $t("common.no") }}
                  </option>

                  <option :value="true">
                    {{ $t("common.yes") }}
                  </option>
                </b-select>
              </b-field>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <b-field
                :label="$t('scaleProducts.category')"
                label-position="on-border"
              >
                <b-select
                  v-model="scaleProduct.c"
                  id="scale-product-c"
                  :placeholder="$t('scaleProducts.category')"
                  expanded
                  @input="fillSubcategories"
                ></b-select>
              </b-field>
            </div>

            <div class="column">
              <b-field
                :label="$t('scaleProducts.subcategory')"
                label-position="on-border"
              >
                <b-select
                  v-model="scaleProduct.s"
                  id="scale-product-s"
                  :placeholder="$t('scaleProducts.subcategory')"
                  :disabled="scaleProduct.c === ''"
                  expanded
                ></b-select>
              </b-field>
            </div>
          </div>
        </b-tab-item>

        <b-tab-item :label="$t('scaleProducts.supportedPatterns')">
          <scale-products-supported-patterns />
        </b-tab-item>
      </b-tabs>
    </section>

    <footer class="modal-card-foot" style="justify-content: space-between;">
      <span>
        <button class="button" type="button" @click="$parent.close()">
          {{ $t("common.cancel") }}
        </button>

        <button
          class="button"
          :style="{
            backgroundColor: $primaryColor,
            color: $primaryColorContrast
          }"
          type="button"
          @click="saveScaleProduct"
          :disabled="!isAbleToRegister"
        >
          {{
            scaleProduct._id
              ? $t("scaleProducts.update")
              : $t("scaleProducts.create")
          }}
        </button>
      </span>

      <button
        class="button is-deep-purple is-pulled-right"
        type="button"
        @click="confirmDeleteScaleProduct"
        v-if="scaleProduct._id"
      >
        {{ $t("scaleProducts.deleteProduct") }}
      </button>
    </footer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Money } from "v-money";
import { common } from "../../mixins/common";
import { mask } from "../../mixins/mask";
import scaleProductsSupportedPatterns from "./ScaleProductsSupportedPatterns";

export default {
  props: ["scaleProductBeingEdited", "storeId"],

  mixins: [common, mask],

  components: {
    Money,
    scaleProductsSupportedPatterns
  },

  data() {
    return {
      isLoading: false,
      scaleProduct: {
        saleType: "",
        option: "",
        digits: "",
        n: "",
        code: "",
        lc: "",
        unit: "",
        c: "",
        s: "",
        a: ""
      },
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2
      }
    };
  },

  methods: {
    saveScaleProduct() {
      const lc = Number(
        String(this.scaleProduct.lc.toFixed(2)).replace(/[^0-9]+/g, "")
      );
      this.isLoading = true;
      this.$store
        .dispatch("saveScaleProduct", {
          action: this.scaleProductBeingEdited._id ? "edit" : "create",
          scaleProduct: {
            ...this.scaleProduct,
            lc
          }
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            this.$emit("get-scale-products");
            this.$parent.close();
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    confirmDeleteScaleProduct() {
      this.$buefy.dialog.confirm({
        title: this.$t("scaleProducts.deleteProduct"),
        message: this.$t("scaleProducts.deleteProductDescription"),
        type: "is-danger",
        hasIcon: true,
        icon: "times-circle",
        iconPack: "fa",
        confirmText: this.$t("common.yes"),
        cancelText: this.$t("common.cancel"),
        onConfirm: () => this.deleteScaleProduct()
      });
    },

    deleteScaleProduct() {
      this.isLoading = true;
      this.$store
        .dispatch("deleteScaleProduct", {
          code: this.scaleProduct.code
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            this.$emit("get-scale-products");
            this.$parent.close();
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    fillSubcategories() {
      if (this.scaleProduct.c !== "") {
        let subcategoryOptions =
          '<option value="" disabled>Escolha uma subcategoria</option>';

        let category = this.categories.filter(c => {
          return c._id === this.scaleProduct.c;
        })[0];

        if (category) {
          let subcategories = category.subcategories;
          const len = subcategories.length;

          for (let i = 0; i < len; i++) {
            subcategoryOptions += `<option value="${subcategories[i]._id}">${subcategories[i].name}</option>`;
          }
        }
        document.getElementById(
          "scale-product-s"
        ).innerHTML = subcategoryOptions;
        document.getElementById("scale-product-s").value = this.scaleProduct.s;
      }
    },

    changeTabsStyle() {
      const tab1 = document.getElementsByClassName("tabs")[0].children[0]
        .children[0];
      const tab2 = document.getElementsByClassName("tabs")[0].children[0]
        .children[1];

      if (tab2.classList.contains("is-active")) {
        tab1.children[0].style.setProperty(
          "border-bottom-color",
          this.$primaryColor,
          "important"
        );
        tab2.children[0].style.setProperty(
          "border-bottom-color",
          "rgb(219, 219, 219)",
          "important"
        );
        tab1.children[0].style.setProperty(
          "color",
          this.$primaryColor,
          "important"
        );
        tab2.children[0].style.setProperty("color", "#4A4A4A", "important");
      } else {
        tab1.children[0].style.setProperty(
          "border-bottom-color",
          "rgb(219, 219, 219)",
          "important"
        );
        tab2.children[0].style.setProperty(
          "border-bottom-color",
          this.$primaryColor,
          "important"
        );
        tab1.children[0].style.setProperty("color", "#4A4A4A", "important");
        tab2.children[0].style.setProperty(
          "color",
          this.$primaryColor,
          "important"
        );
      }
    }
  },

  computed: {
    ...mapGetters(["categories", "payments"]),

    isAbleToRegister() {
      return (
        this.scaleProduct.saleType !== "" &&
        this.scaleProduct.option !== "" &&
        this.scaleProduct.digits !== "" &&
        this.scaleProduct.n !== "" &&
        this.scaleProduct.code !== "" &&
        this.scaleProduct.code.length === this.scaleProduct.digits &&
        this.scaleProduct.unit !== "" &&
        this.scaleProduct.c !== "" &&
        this.scaleProduct.s !== "" &&
        this.scaleProduct.a !== ""
      );
    }
  },

  mounted() {
    this.money.prefix = `${this.payments.currencySymbol} `;

    if (this.scaleProductBeingEdited._id) {
      this.scaleProduct = {
        ...this.scaleProductBeingEdited,
        lc: this.scaleProductBeingEdited.lc / 100
      };
    }

    let i,
      len = this.categories.length;
    let categoryOptions = `<option value="" disabled>${this.$t(
      "scaleProducts.pickCategory"
    )}</option>`;
    for (i = 0; i < len; i++) {
      categoryOptions += `<option value="${this.categories[i]._id}">${this.categories[i].name}</option>`;
    }
    document.getElementById("scale-product-c").innerHTML = categoryOptions;
    document.getElementById("scale-product-c").value = this.scaleProduct.c;

    this.$nextTick(() => {
      const tab1 = document.getElementsByClassName("tabs")[0].children[0]
        .children[0];
      tab1.children[0].style.setProperty(
        "color",
        this.$primaryColor,
        "important"
      );
      tab1.children[0].style.setProperty(
        "border-bottom-color",
        this.$primaryColor,
        "important"
      );

      const tab2 = document.getElementsByClassName("tabs")[0].children[0]
        .children[1];
      tab2.children[0].style.setProperty("color", "4A4A4A", "important");
    });

    this.fillSubcategories();
  }
};
</script>
